import React from 'react';
import loadable from '@loadable/component';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import { fireLanding, hasFiredLanding } from '../modules/analytics/landing';
import { IRouteState } from '../../../packages/router';
import store from '../store';
import AppInstallBanner from './shared/AppInstallBanner';
import StateRouterConnector from './shared/StateRouterConnector';
import { routeConfigs } from '../react-routes';
import ForceTOSAccept from './shared/legal/ForceTOSAccept';
import ConnectedSnackbar from './ui/Snackbar';
import * as CJTracking from '../modules/CJTracking/CJTracking';
import { StripeTerminalConnector } from './provider/StripeTerminal/StripeTerminalConnector';

const AngularApp = loadable(() => import('./AngularApp'));
/**
 * Main React App
 * @constructor
 */
const App = () => {
  const handleInitialLanding = (route: IRouteState) => {
    if (!hasFiredLanding()) {
      fireLanding(route);
    }

    if (route.params.TYPE) {
      CJTracking.storeParams({
        CJEVENT: route.params.CJEVENT,
        TYPE: route.params.TYPE,
      });
    }
  };

  return (
    <Provider store={store}>
      <AppInstallBanner />
      <StateRouterConnector
        routes={routeConfigs}
        onInitialLanding={handleInitialLanding}
      >
        {/* when none of the route configs can handle a route state, render the angular app */}
        <Route>
          <AngularApp />
        </Route>
      </StateRouterConnector>
      <ForceTOSAccept />
      <ConnectedSnackbar />
      <StripeTerminalConnector />
    </Provider>
  );
};

export default App;
